import Rest from '@services/Rest'

/**
 * @typedef {UserFlagsService}
 */
export default class UserFlagsService extends Rest {
  /**
   * @type {String}
   */
  static resource = 'admin/user-flags'
}
